// extracted by mini-css-extract-plugin
module.exports = {"slotLabel":"InventorySlot_slotLabel__qdgGO","slotValue":"InventorySlot_slotValue__3cSoc","other":"InventorySlot_other__1Vr80","slotWrapper":"InventorySlot_slotWrapper__sVFBU"};